<template>
  <header class="app-layout__header">
    <DashboardBanner />
    <NavbarMobile v-if="isMobile" />
  </header>
</template>

<script lang="ts" setup>
const isMobile = ref(false)

onMounted(() => {
  checkMobile()
  window.addEventListener('resize', checkMobile)
})

onUnmounted(() => {
  window.removeEventListener('resize', checkMobile)
})

function checkMobile() {
  isMobile.value = window.innerWidth < 1024
}
</script>

<style></style>
